jQuery(document).ready(function () {
  var $ = jQuery;
  var videoContainer = $('<div class="product-video-container-modal"></div>');
  var video;

  videoContainer.hide();
  videoContainer.click(function (e) {
    if (e.target.tagName.toLowerCase() === 'video') {
      return;
    }

    video[0].pause();
    $(this).fadeOut();
  });

  $('body').append(videoContainer);

  $('.external-links .product-video a').click(function (e) {
    e.preventDefault();

    if ($(this).attr('loaded') !== '1') {
      video = $('<video autoplay loop controls src="' + $(this).attr('href') + '"></video>')
      videoContainer.append(video);

      $(this).attr('loaded', '1');
    }

    video[0].play();
    videoContainer.fadeIn();
  });
});
